module.exports = __webpack_public_path__ + "img/type-zfb.63803842.png";